// import { subscribeScript } from "./subscribe.js";

document.addEventListener("DOMContentLoaded", function () {
    let popupTrigger = document.getElementById("openSubscribePopup");
    let popup = document.getElementById("subscribe");
    let closePopup = document.getElementById("closeSubscribePopup");

    if (popupTrigger && popup) {
        popupTrigger.addEventListener("click", function (event) {
            event.preventDefault();
            popup.classList.remove("hidden");
            popup.classList.add("flex");

            setTimeout(() => {
                subscribeScript();
            }, 200);
        });
    }

    // Close popup button
    if (closePopup) {
        closePopup.addEventListener("click", function () {
            popup.classList.add("hidden");
            popup.classList.remove("flex");
        });
    }

    // Close the popup when clicking outside the modal
    popup.addEventListener("click", function (event) {
        if (event.target === popup) {
            popup.classList.add("hidden");
            popup.classList.remove("flex");
        }
    });
});
